import { Cookies } from 'react-cookie';

import { ChartSignal } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getTrapDetailHeatMapSRBMChart = async (slug: string, start_datetime: string, end_datetime: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`api/v1/traps/bait-activation-signals/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      start_datetime: start_datetime,
      end_datetime: end_datetime,
    },
  });
  return data.data as ChartSignal[];
};
